// extracted by mini-css-extract-plugin
export var arc = "TextBlocksModule-module--arc--434cb";
export var arrowUpAndDown = "TextBlocksModule-module--arrow-up-and-down--1d7ac";
export var backgroundImageContainer = "TextBlocksModule-module--backgroundImageContainer--92be2";
export var blockContainer = "TextBlocksModule-module--blockContainer--b05ff";
export var blockLink = "TextBlocksModule-module--blockLink--8ae61";
export var blockTitle = "TextBlocksModule-module--blockTitle--4461b";
export var blocks = "TextBlocksModule-module--blocks--5f371";
export var content = "TextBlocksModule-module--content--c8ecd";
export var contentContainer = "TextBlocksModule-module--contentContainer--7d5e5";
export var contentWrapper = "TextBlocksModule-module--contentWrapper--d2bf1";
export var desktop = "TextBlocksModule-module--desktop--91da2";
export var leftBranch = "TextBlocksModule-module--leftBranch--f5e96";
export var link = "TextBlocksModule-module--link--283d7";
export var mobile = "TextBlocksModule-module--mobile--fcd23";
export var rightBranch = "TextBlocksModule-module--rightBranch--46eb8";
export var textOuterWrapper = "TextBlocksModule-module--textOuterWrapper--03103";